import React, {useEffect, useState, useRef} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@mui/styles'

const useStyles = makeStyles({
  outerContainer: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  progressBar: {
    height: '100%',
  },
})

function ProgressBar({progress, color}) {
  const classes = useStyles()
  const barRef = useRef()
  const [borderRadius, setBorderRadius] = useState()

  useEffect(() => {
    if (!barRef.current) {
      return
    }
    setBorderRadius(barRef.current.clientHeight / 2)
  }, [])

  return (
    <div className={classes.outerContainer} style={{border: `1px solid ${color}`, borderRadius: borderRadius}} ref={barRef}>
      <div className={classes.progressBar} style={{width: `${progress * 100}%`, backgroundColor: color}} />
    </div>
  )
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
}

export default ProgressBar
